import store from 'store'

const getAccessToken = () => {
  return new Promise((resolve) => {
    window.$jfs.getAppInfoFunc()
      .then(res => {
        localStorage.setItem('access_token', res.accessToken)
        sessionStorage.setItem('uid', res.uid) // 获取该商户的uid
        store.dispatch('SetAccessToken', res.accessToken)
        resolve(res.accessToken)
      })
  })
}

export default getAccessToken
